import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzHlwn65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_65: Record<
  Exclude<PageIdWoofzHlwn65, PageIdWoofzHlwn65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_65]: {
    id: PageId.SUBSCRIPTIONS_PAGE_HLWN_65,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_HLWN_65]: {
    id: PageId.CHAT_UPSELL_HLWN_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_HLWN_65]: {
    id: PageId.UPSELL_HLWN_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_HLWN_65]: {
    id: PageId.DOWNLOAD_HLWN_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
